export const channel_new_game = "new_game"
export const channel_cancel_new_game = "cancel_new_game"
// client -> server: { level: BotLevel }, starts a game against the bot; ends a search for an opponent.
export const channel_new_bot_game = "new_bot_game"
export const channel_on_game_start = "on_game_start"
export const channel_game_move = "game_move"
export const channel_on_game_update = "on_game_update"
export const channel_leave_game = "leave_game"
export const channel_on_game_end = "on_game_end"
export const channel_on_game_crashed = "on_game_crashed"
export const channel_on_game_user_leave = "on_game_user_leave"
export const channel_ping = "ping"
export const channel_pong = "pong"
export const channel_on_user_connection_change = "channel_on_user_connection_change"
export const channel_listen_game_events = "channel_listen_game_events"
export const channel_unlisten_game_events = "channel_unlisten_game_events"
// Auth handshake. client -> server: { token } right after connecting and again after a token refresh;
// other messages are ignored until the server answers on_auth with { user }.
export const channel_auth = "auth"
export const channel_on_auth = "on_auth"
// server -> client: { reason }, sent right before the server closes the socket with CLOSE_AUTH_FAILED.
export const channel_on_auth_error = "on_auth_error"
export const CLOSE_AUTH_FAILED = 4001

// Home page previews. client -> server: subscribe_live_games / unsubscribe_live_games;
// server -> client: on_live_games with { games: LiveGameSummary[] }.
export const channel_subscribe_live_games = "subscribe_live_games"
export const channel_unsubscribe_live_games = "unsubscribe_live_games"
export const channel_on_live_games = "on_live_games"
// server -> client: { gameId }, when new_game is sent while the user has a game in progress.
export const channel_on_new_game_rejected = "on_new_game_rejected"

// Rematches (docs/specs/rematch). client -> server: rematch { gameId } asks for a rematch of an ended game or accepts
// the opponent's request; decline_rematch { gameId } says no or withdraws one's own request.
// server -> client: on_rematch_request (RematchRequest) when the opponent asks; on_rematch_ended (RematchEnded) to both
// players when a request or the chance of a rematch ends. The next game arrives as on_game_start.
export const channel_rematch = "rematch"
export const channel_decline_rematch = "decline_rematch"
export const channel_on_rematch_request = "on_rematch_request"
export const channel_on_rematch_ended = "on_rematch_ended"
